const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the workshop search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('workshopsSearch', ['Workshops', '$q', function (Workshops, $q) {
  return {
    restrict: 'E',
    scope: {
      startItems: '=',
      onChange: '&',
      selectionLimit: '@',
      clear: '='
    },
    template: require('../../templates/directives/workshops-searchbar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];
      self.updateQuery = function () {
        $scope.onChange({items: self.queries});
      };
      self.given = {
        parse: function () {
          if (!$scope.startItems || !$scope.startItems.length) {
            return;
          }
          var promises = [];
          for (var i = 0; i < $scope.startItems.length; i++) {
            var id = !$scope.startItems[i] ? null : $scope.startItems[i]._id ? $scope.startItems[i]._id : $scope.startItems[i].id ? $scope.startItems[i].id : $scope.startItems[i];
            if (!id || typeof id !== 'string') {
              continue;
            }
            var promise = Workshops.get({subresource: id, fields: 'title'}).$promise;
            if (!promise) {
              continue;
            }
            promises.push(promise);
          }
          $q.all(promises).then(function(items) {
            for (var i = 0; i < items.length; i++) {
              self.queries.push({
                name: items[i].title,
                text: items[i].title,
                _id: items[i]._id,
                type: 'workshop'
              });
            }
          });
        }
      };
      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag._id || !$tag.type || !$tag.name) {
            return false;
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              self.queries.splice(0, 1);
            }
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.getOptions = function (input) {
        if (!initClosed) {
          initClosed++;
          initWatch();
        }
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var placeholders = {
          workshop: {name: 'Workshops', text: 'Workshops', _id: 'workshops', placeholder: true}
        };
        var addedItems = {
          workshops: false
        };

        var contentQuery = {
          subresource: '',
          page: 1,
          per_page: 6,
          fields: 'title,tags',
          $or: '10,title,$regex,2,' + input + ',i,tags,$regex,2,' + input + ',i'
        };

        var workshopsPromise = Workshops.find(contentQuery).$promise;

        $q.all([workshopsPromise])
        .then(function (results) {
          var directory = {
            0: 'workshop'
          };
          var items = [];
          for (var i = 0; i < results.length; i++) {
            if (!results[i] || !results[i].length) {
              continue;
            }
            var type = directory[i];
            if (!addedItems[type]) {
              items.push(placeholders[type]);
              addedItems[type] = true;
            }
            for (var j = 0; j < results[i].length; j++) {
              items.push({
                name: results[i][j].title || results[i][j].name,
                text: results[i][j].title || results[i][j].name,
                _id: results[i][j]._id,
                type: type
              });
            }
          }
          deferred.resolve(items);
        }).catch(function (error) {
          // error messaging
        });

        return deferred.promise;
      };

      var initClosed = 0;
      var initWatch = $scope.$watch('startItems', function(newVal, oldVal) {
        if (newVal) {
          self.given.parse();
          initWatch();
        }
      });
      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.tagInput.clear(true);
          $scope.clear = false;
        }
      });
    }],
    controllerAs: 'search'
  };
}]);
